import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'prefix',
})
export class PrefixPipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  transform(
    value?: number | null,
    translationKey = '',
    isTranslate = true,
  ): string {
    if (isTranslate) {
      return value
        ? `${value} ${this.translocoService.translate(translationKey)}`
        : '-';
    } else {
      return value ? `${value} ${translationKey}` : '-';
    }
  }
}
